<div class="tab-pane" id="menu1">
    <div class="row" *ngIf='loader'>
        <app-sura-loader></app-sura-loader>
    </div>
    <div class="row" *ngIf='!loader'>
        <div class="col-xs-12">
            <div class="box-title col-xs-12">
                <h3>Última actualización:<strong id="cicloViajes"> {{ ultimaActualizacion }}</strong></h3>
            </div>
        </div>
        <div class="col-xs-12">
            <div class="box-fecha">
                <div class="box-fecha__select">
                    <app-sura-select-mis-viajes [elements]="listaMeses" (selected)="onSelectMonth($event)">
                    </app-sura-select-mis-viajes>
                </div>
                <div class="box-fecha__km">
                    <div class="box-fecha__km-number"><span *ngFor="let letter of selectedKms.split('')">{{ letter }}</span></div>

                </div>
                <div class="box-fecha__km">
                <h2 style="padding-left: 70px;">KMS.</h2>
                    <div class="box-fecha__km-info" id="clickInfo"  style="z-index: 1000;">
                        <a href="javascript:void(0);"  (click)="scroll()" placement="button" style="z-index: 1060;"></a>
                    </div>
                </div>
              </div>
        </div>
        <div class="col-xs-12">
            <div class="box-line"></div>
        </div>
        <!-- DATE-->
        <app-timeline [selectedMonth]="selectedMonth" (selectedDay)="onSelectDay($event)"></app-timeline>
        <!-- DATA-->
        <div>
            <div class="col-xs-12" *ngIf="tripsDayData == undefined || tripsDayData == null ||   selectedTripsDay == undefined || selectedTripsDay.length == 0">

                <!-- BOX DATA-->

                <div class="box-data nodata">

                    <h3>No tienes viajes registrados para hoy</h3><img class="img-nodata" src="/assets/img/sura-image-sin-viajes.svg" alt="SIN DATOS" />

                </div>

            </div>
            <div class="col-xs-12" *ngIf="tripsDayData != undefined && tripsDayData != null && selectedTripsDay != undefined && selectedTripsDay.length > 0">
                <!-- BOX DATA-->
                <div class="box-data">
                    <div class="box-data-details">
                        <div class="box-data-details-head">
                            <div class="table-responsive">
                                <table class="table table-striped table-borderless">
                                    <thead>
                                        <tr>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col">&nbsp;</th>
                                            <th scope="col">&nbsp;</th>
                                            <th class="table-head" scope="col" align="center"><img class="tiempo" src="/assets/img/sura-icon-reloj.svg" alt="SURA ICON RELOJ" /><strong>Tiempo</strong></th>
                                            <th class="table-head" scope="col" align="center"><img class="distancia" src="/assets/img/sura-icon-distancia.svg" alt="SURA ICON DISTANCIA" /><strong>Distancia</strong></th>
                                            <th class="table-head" scope="col" align="center"><img class="gasto" src="/assets/img/sura-icon-gasto.svg" alt="SURA ICON GASTO" /><strong>Gasto</strong></th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                        <div class="box-data-details-table">
                            <app-lista-viajes [trips]="selectedTripsDay" (selectedRoute)="onSelectRoute($event)" [selectedTrip]="selectedTrip"></app-lista-viajes>
                        </div>
                    </div>
                    <!-- BOX MAPA-->
                    <div class="box-data-map">
                        <div class="box-data-map__head"><img src="/assets/img/sura-icon-map.svg" alt="SURA ICON MAP" />
                            <h4>Conocer última ubicación reportada</h4>
                        </div>
                        <div class="row relative" *ngIf='loaderMap' style="display: inline;">
                          <app-sura-loader></app-sura-loader>
                        </div>
                        <app-mapa-ruta [coordinates]="selectedTripCoordinates" *ngIf="mapTrip"></app-mapa-ruta>
                        <div class="box-data nodata" *ngIf="!mapTrip">
                            <h3>No tienes viajes registrados para hoy</h3>
                            <img class="img-nodata" src="/assets/img/sura-image-sin-viajes.svg" alt="SIN DATOS" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- RESUMEN-->
        <div class="col-xs-12" *ngIf="tripsDayData != null">
            <div class="box-resumen" *ngIf=!loaderMap>
                <div class="box-resumen-data"><img class="ruta" src="/assets/img/sura-icon-reloj.svg" alt="SURA ICON RUTA" />
                    <div class="box-resumen-data__details">
                        <h6>Conducción del día</h6>
                        <h4 id="minutos">{{ tripsDayData.dayDrivingTime.toString() }} min.</h4>
                    </div>
                </div>
                <div class="box-resumen-data"><img class="distancia" src="/assets/img/sura-icon-distancia.svg" alt="SURA ICON DISTANCIA" />
                    <div class="box-resumen-data__details">
                        <h6>Distancia recorrida</h6>
                        <h4 id="distanciaKms">{{ tripsDayData.dayTotalTraveled.toString() }} kms.</h4>
                    </div>
                </div>
                <div class="box-resumen-data"><img class="gasto" src="/assets/img/sura-icon-gasto.svg" alt="SURA ICON GASTO" />
                    <div class="box-resumen-data__details">
                        <h6>Gasto total del día</h6>
                        <h4 id="gastoDiario">{{ tripsDayData.daySpended | currency:"CLP":"$":0:'es_CL' }}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12" *ngIf=!loaderMap>
            <div class="box-resumen-info" #info><img class="img-fluid" src="/assets/img/sura-icon-info.svg" alt="SURA ICON INFO" />
                <p>Recuerda que los viajes se muestran mensualmente, pero para tu facturación sigue siendo <strong>desde el día 25 del presente mes hasta el 24 del mes siguiente.</strong></p>
            </div>
        </div>
    </div>
